import React from 'react'
import { Typography } from '@mui/material'

import { MAX_ALLOWED_CUSTOM_FIELDS } from '../../constants'
import { CustomFieldsForm } from '../../settings/CustomFields'

const Setup = ({ fieldState, setFieldState, types }) => {
  return (
    <>
      <Typography sx={{ mb: 2 }}>
        To make your job a little easier, we started you out with some basic
        examples of custom field options that you can change as you like. You
        can add up to {MAX_ALLOWED_CUSTOM_FIELDS} of these custom fields.
      </Typography>
      <Typography>
        As the administrator, you can change these fields anytime that you would
        like. General users will not be able to make these system wide changes
        in the CRM - The tail doesn't wag the dog!
      </Typography>

      <CustomFieldsForm
        fieldState={fieldState}
        setFieldState={setFieldState}
        types={types}
      />
    </>
  )
}

export default Setup
